
import React from 'react';
import { ItineraryEvent } from '@/types/itinerary';
import { PlaneTakeoff, Train, Bus, Car, Sailboat, Ship } from 'lucide-react';

interface TransportationIconProps {
  event: ItineraryEvent;
  size?: number;
}

export const TransportationIcon: React.FC<TransportationIconProps> = ({ 
  event,
  size = 16
}) => {
  const title = event.title?.toLowerCase() || '';
  const location = event.location?.toLowerCase() || '';
  const description = event.description?.toLowerCase() || '';
  
  // Combined text for better matching
  const combinedText = `${title} ${location} ${description}`;
  
  const className = `h-${size/4} w-${size/4}`;
  
  // Define icon based on transportation type keywords
  if (combinedText.includes('flight') || 
      combinedText.includes('plane') || 
      combinedText.includes('airport') || 
      combinedText.includes('air')) {
    return <PlaneTakeoff className={className} style={{color: '#0ea5e9'}} />; // sky-500
  }
  
  if (combinedText.includes('train') || 
      combinedText.includes('rail') || 
      combinedText.includes('railway') || 
      combinedText.includes('amtrak')) {
    return <Train className={className} style={{color: '#ef4444'}} />; // red-500
  }
  
  if (combinedText.includes('bus') || 
      combinedText.includes('coach') || 
      combinedText.includes('shuttle')) {
    return <Bus className={className} style={{color: '#f59e0b'}} />; // amber-500
  }
  
  if (combinedText.includes('car') || 
      combinedText.includes('taxi') || 
      combinedText.includes('uber') || 
      combinedText.includes('lyft') || 
      combinedText.includes('drive')) {
    return <Car className={className} style={{color: '#22c55e'}} />; // green-500
  }
  
  if (combinedText.includes('ferry') || 
      combinedText.includes('boat') || 
      combinedText.includes('sail')) {
    return <Sailboat className={className} style={{color: '#3b82f6'}} />; // blue-500
  }
  
  if (combinedText.includes('cruise') || 
      combinedText.includes('ship')) {
    return <Ship className={className} style={{color: '#6366f1'}} />; // indigo-500
  }
  
  // Default icon
  return <PlaneTakeoff className={className} style={{color: '#7E69AB'}} />; // glowingTeal
};
